module.exports = __webpack_public_path__ + "media/images/honey/500g_bottle-79c9165514c46587359b98f71290fede.png";